import { mapGetters, mapState } from 'vuex';
import isNil from 'lodash/isNil';
import * as log from 'loglevel';
import get from 'lodash/get';

export default {
  data() {
    return {
      isSummarizing: false,
      summary: '',
    };
  },

  computed: {
    ...mapGetters({
      conversationsMessages: 'conversations/conversationsMessages',
    }),
    ...mapState({
      conversationSummaryConfig: state => state.featureFlags.conversationSummaryConfig,
    }),
    canSummarize() {
      return this.canView('/conversations/chat_panel/summarize');
    },
  },

  methods: {
    isConversationSummarizable(conversationId) {
      return this.canSummarize && this.getIsSummarizable(conversationId);
    },

    async onSummary(conversationId) {
      this.isSummarizing = true;
      this.summary = await this.$store.dispatch('conversations/getSummary', conversationId);
      // Exceptional case:
      // Backend may return empty summary if there is nothing to summarize.
      // Most likely, this case is handled by message count threshold.
      if (!this.summary) {
        this.summary = 'N/A';
      }
      this.isSummarizing = false;
    },

    async onMetricsSummary(summaryName, summaryData, summaryRange) {
      this.isSummarizing = true;
      try {
        this.summary = await this.$store.dispatch('metrics/getSummary', {
          metricsName: summaryName,
          metricsRange: summaryRange,
          summaryData,
        });
      } catch (error) {
        log.error('Error getting summary:', error);
      }

      // Backend may return empty summary if there is nothing to summarize.
      // Most likely, this case is handled by message count threshold.
      if (!this.summary) {
        this.summary = 'N/A';
      }
      this.isSummarizing = false;
    },

    getIsSummarizable(conversationId) {

      if (!conversationId || !this.conversationSummaryConfig) {
        return false;
      }

      const messages = get(this.conversationsMessages, conversationId, []);
      const messageCount = messages.filter(m => {
        return !m.event && !isNil(m.sender_id);
      }).length;
      return messageCount >= this.conversationSummaryConfig.messageCountThreshold;
    },
  },
};
